import { useOfflinePurchases, useQuery } from "@jti/rest-api";

import { getCurrentMagentoClient, IScopeTypeEnum } from "../..";

type OfflinePurchases = {
  isLoading?: boolean;
  onlineOrdersCount?: number;
  offlineOrdersCount?: number;
};

export const useOrdersList = (isFreeTrial: boolean, isOfflineOrderEnabled?: boolean): OfflinePurchases => {
  const { data, isLoading } = useQuery(isFreeTrial ? "getFreeTrialOrdersCount" : "getOrdersCount", () =>
    getCurrentMagentoClient(isFreeTrial).getCustomerOrdersCount(IScopeTypeEnum.Website)
  );

  const { data: offlinePurchases, isLoading: isOfflinePurchasesLoading } = useOfflinePurchases(
    Boolean(isOfflineOrderEnabled)
  );

  return {
    onlineOrdersCount: data?.customer.orders.total_count,
    offlineOrdersCount: offlinePurchases?.data?.length,
    isLoading: isOfflinePurchasesLoading || isLoading,
  };
};
